/** Nome do país/região no idioma da tela ("BR" → "Brazil"); código cru se o navegador não souber. */
export function countryName(code: string, language: string): string {
  try {
    return new Intl.DisplayNames([language], { type: "region" }).of(code) ?? code;
  } catch {
    return code;
  }
}

/** Lista curta para caber no cabeçalho: os três primeiros por nome e "+N". */
export function countrySummary(codes: string[], language: string, shown = 3): string {
  const names = codes.map((code) => countryName(code, language)).sort((a, b) => a.localeCompare(b));
  const rest = names.length - shown;
  return rest > 0 ? `${names.slice(0, shown).join(", ")} +${rest}` : names.join(", ");
}
